import { useState, useCallback } from "react";
import { AndamentoCompatibilidade, buscarAndamentosCompatibilidadeService } from "../../../services/buscarAndamentosCompatibilidadeService";

export const useBuscarAndamentosCompatibilidade = () => {
  const [andamentos, setAndamentos] = useState<AndamentoCompatibilidade[]>([]);
  const [loading, setLoading] = useState(false);

  const buscar = useCallback(async (compatibilidadeId: number) => {
    if (!compatibilidadeId) return;
    
    setLoading(true);
    try {
      const dados = await buscarAndamentosCompatibilidadeService(compatibilidadeId);
      setAndamentos(dados);
    } catch (error) {
      console.error("Erro ao buscar andamentos:", error);
      setAndamentos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    andamentos,
    loading,
    buscar,
  };
};
